/* */ 
"use strict";
function __export(m) {
  for (var p in m)
    if (!exports.hasOwnProperty(p))
      exports[p] = m[p];
}
__export(require('./platform_browser_dynamic'));
